import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { AppLoader } from "@/shared/Components";
import { useAppDispatch } from "@/services/store";
import { logout, setRefreshToken } from "@/services/auth";
import { FlowType, paymentActions, PaymentForm } from "@/features/payment-form";
import { appRouterPaths } from "@/services/navigation";
import i18n from "@/services/i18n";
import { setSelectedLang } from "@/services/i18n/slice/state";
import { LANGUAGE_KEY, type Language } from "@/services/i18n/slice/types";
import { Layout } from "../Layout";
import { checkLocale } from "../../helpers";

export const MobilePayments = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const refresh = searchParams.get("refresh");
  const locale = checkLocale(searchParams, i18n.languages);

  useEffect(() => {
    if (locale) {
      dispatch(setSelectedLang(locale as Language));
      i18n.changeLanguage(locale);
      localStorage.setItem(LANGUAGE_KEY, locale);
    }
  }, [locale]);

  useEffect(() => {
    if (refresh) {
      dispatch(logout());
      dispatch(paymentActions.resetPaymentState());
      dispatch(setRefreshToken(refresh));
      return;
    }

    navigate(appRouterPaths.logIn);
  }, [refresh, dispatch]);

  return (
    <Layout>{!refresh ? <AppLoader /> : <PaymentForm flowType={FlowType.MOBILE_PAYMENT} />}</Layout>
  );
};
